import styled from '@emotion/styled';
import { Variables } from '../base';

export const Result = styled.div`
    flex: 1 1 auto;
    border-bottom: ${Variables.Borders.regular};
`;

export const Patient = styled.div`
    display: flex;
    flex-direction: column;
    padding: 8px 8px;
`;
export const PatientTop = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 14px;
    color: ${Variables.Colors.n50};

    b {
        font-weight: 500;
        margin-right: 4px;
    }
    span {
        margin-right: 24px;
    }
`;
export const PatientBottom = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 4px;
    align-items: center;
`;
export const PatientName = styled.div`
    font-size: 18px;
    color: ${Variables.Colors.n100};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
export const ClaimTable = styled.table`
    width: 100%;
    border-spacing: 0;
`;

export const Spacer = styled.div`
    flex-grow: 1;
    min-width: 12px;
`;
